/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ListOtherEmployersForCompanyEmployerFromJSON, ListOtherEmployersForCompanyEmployerToJSON, } from './ListOtherEmployersForCompanyEmployer.js';
/**
 * Check if a given object implements the ListOtherEmployersForCompanyResult interface.
 */
export function instanceOfListOtherEmployersForCompanyResult(value) {
    if (!('employers' in value) || value['employers'] === undefined)
        return false;
    return true;
}
export function ListOtherEmployersForCompanyResultFromJSON(json) {
    return ListOtherEmployersForCompanyResultFromJSONTyped(json, false);
}
export function ListOtherEmployersForCompanyResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employers': (json['employers'].map(ListOtherEmployersForCompanyEmployerFromJSON)),
    };
}
export function ListOtherEmployersForCompanyResultToJSON(json) {
    return ListOtherEmployersForCompanyResultToJSONTyped(json, false);
}
export function ListOtherEmployersForCompanyResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'employers': (value['employers'].map(ListOtherEmployersForCompanyEmployerToJSON)),
    };
}
